import { connect } from 'react-redux'
import Table from './Table'

import onChangeTable from './Handlers/onChangeTable'

const mapStateToProps = (state) => ({
  subOrders: state.screens.SubProject.SubOrders.subOrders,
  fetching: state.screens.SubProject.SubOrders.fetching,
})

const actionCreators = {
  onChangeTable,
}

export default connect(mapStateToProps, actionCreators)(Table)
